// Types of users in TRUS
export enum UserRole {
  // LoanOfficer = "loan_officer",
  // SettlementAgent = "settlement_agent",
  Underwriter = "underwriter",
  LoanManager = "loan_manager",
}
